export const getMyGroupMembers = (axiosInstance, page, resultLimit) => {
    const url = `/v1/current/player-group?page=${page}&pageSize=${resultLimit}`;
    return axiosInstance.get(url);
};

export const getAddMemberShareLink = (axiosInstance, playerId) => {
    const url = `/v1/player-group/${playerId}`;
    return axiosInstance.get(url);
};

export const authenticatePlayerGroupShareLink = (axiosInstance, playerId, link) => {
    const url = `/v1/player-group/${playerId}`;
    return axiosInstance.post(url, link);
};
